import {Pipe, PipeTransform} from '@angular/core';
import {keys}                from 'lodash';
import * as moment           from 'moment';
import IField = Data.FieldManagement.IField;

@Pipe({
  name: 'apCampaignyearCropConverter'
})
export class ApCampaignyearCropConverterPipe implements PipeTransform {

  transform(fields: IField[], args?: any): any {
    let counter = 1;
    const selectedValues = {};
    for (const field of fields) {
      for (const crop of field.FieldCrops) {
        const key = moment(crop.ValidTo).year() + '_' + crop.Cropkey;
        if (!selectedValues[key]) {
          selectedValues[key] = {
            Id: counter++,
            main_second_crop_type: crop.MainSecondCropType,
            avg: 0,
            sum: 0,
            count: 0,
            cropkey: crop.Cropkey,
          };
        }
        selectedValues[key].count++;
        selectedValues[key].sum = fields.length;
      }
      for (const k of keys(selectedValues)) {
        selectedValues[k].avg = selectedValues[k].sum * selectedValues[k].count / 100;
      }
    }
    return selectedValues;
  }
}
